const checkEmptyTags = (richTextHTML: string | null | undefined) => {
  if (richTextHTML) {
    return richTextHTML.replace(/(<([^>]+)>)/gi, '');
  } else {
    return richTextHTML;
  }
};

export default checkEmptyTags;
